import { render } from "./AnsweredTickets.vue?vue&type=template&id=88e34810&ts=true"
import script from "./AnsweredTickets.vue?vue&type=script&lang=ts"
export * from "./AnsweredTickets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__